<template>
  <div class="common">
    <a-tabs v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name" >
        <keep-alive v-if="tabCur==item.key">
          <component 
          :is="item.comp" 
          :tabType="item.key"
          ></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import characterMain from "@/pages/system/character/character-main.vue"
export default {
  components: {
    characterMain
  },
  name:"character",
  data() {
    return {
      tabData:[
        {
          name:"角色管理",
          key:"character",
          comp:characterMain,
          status:"0",
        }
      ],
      tabCur:"character"
    }
  },
  computed:{
    ...mapGetters({
        userObj:"home/getUserObj"

    })
  },
  created() {
  },
  mounted() {
    
  },
  methods: {
    
    
  },
  activated() {

  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/system/character/character.vue